import Rails from '@rails/ujs'

const LAST_ACTIVITY_KEY = 'last_activity'
const DEFAULT_TIMEOUT = 50 * 60 * 1000
const THROTTLE_TIME = 5000


const storage = {
  get: (key) => {
    try { return Number(localStorage.getItem(key)) || 0 }
    catch { return 0 }
  },
  set: (key, value) => {
    try { localStorage.setItem(key, value) }
    catch { }
  }
}


export default function idleLogout(timeout = DEFAULT_TIMEOUT) {
  let logoutTimer = null
  let isLoggingOut = false

  if (window.__idleLogoutActive) return
  window.__idleLogoutActive = true

  const now = Date.now()
  const lastStored = storage.get(LAST_ACTIVITY_KEY)

  if (!lastStored || lastStored <= 0) {
    storage.set(LAST_ACTIVITY_KEY, now)
  }

  const logoutUser = () => {
    if (isLoggingOut) return

    const last = storage.get(LAST_ACTIVITY_KEY)
    if (last <= 0) return

    isLoggingOut = true
    storage.set(LAST_ACTIVITY_KEY, 0)

    Rails.ajax({
      url: '/timeout',
      type: 'GET',
      dataType: 'script',
      success: () => { window.location.href = '/accounts/sign_in' },
      error: () => { window.location.href = '/accounts/sign_in' }
    })
  }

  const scheduleLogout = () => {
    if (logoutTimer) clearTimeout(logoutTimer)
    if (isLoggingOut) return

    const last = storage.get(LAST_ACTIVITY_KEY)
    if (last <= 0) return

    const timeLeft = timeout - (Date.now() - last)

    if (timeLeft > 0) {
      logoutTimer = setTimeout(logoutUser, timeLeft)
    } else {
      logoutUser()
    }
  }

  const resetActivity = () => {
    if (isLoggingOut) return

    const last = storage.get(LAST_ACTIVITY_KEY)
    if (last <= 0) return

    storage.set(LAST_ACTIVITY_KEY, Date.now())

    scheduleLogout()
  }

  let throttleTimer = null
  const throttledReset = () => {
    if (throttleTimer) return

    throttleTimer = setTimeout(() => {
      throttleTimer = null
      resetActivity()
    }, THROTTLE_TIME)
  }

  const events = ['mousemove', 'mousedown', 'touchstart', 'click', 'scroll', 'keydown']
  events.forEach(e => window.addEventListener(e, throttledReset, true))

  const onStorage = (event) => {
    if (event.key !== LAST_ACTIVITY_KEY) return

    const newVal = Number(event.newValue)

    if (newVal <= 0) {
      isLoggingOut = true
      window.location.href = '/accounts/sign_in'
      return
    }

    scheduleLogout()
  }

  window.addEventListener('storage', onStorage)

  const cleanup = () => {
    if (logoutTimer) clearTimeout(logoutTimer)
    if (throttleTimer) clearTimeout(throttleTimer)

    events.forEach(e => window.removeEventListener(e, throttledReset, true))

    window.removeEventListener('storage', onStorage)
    window.removeEventListener('turbolinks:before-visit', cleanup)

    window.__idleLogoutActive = false
  }

  window.addEventListener('turbolinks:before-visit', cleanup)

  // Initialize
  scheduleLogout()
}